import { Table } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import sha1 from 'sha1';
import RoamingStore from '../../../stores/RoamingStore';
import ServicePriceItem from './ServicePriceItem';

interface GroupServiceTableProps {
  serviceGroupId: number;
  roamingStore?: RoamingStore;
}

@observer
class GroupServiceTable extends React.Component<GroupServiceTableProps> {
  public render() {
    return (
      <Table>
        <tbody>{this.getTableRows()}</tbody>
      </Table>
    );
  }

  private getTableRows() {
    if (!this.props.roamingStore.selectedOperator) {
      return null;
    }
    const dataRows: any = [];
    this.pushServiceGroupTableRows(dataRows);
    return dataRows;
  }

  private pushServiceGroupTableRows(dataRows: any) {
    const {
      serviceGroupId,
      roamingStore: { selectedOperator }
    } = this.props;
    const serviceGroup = this.props.roamingStore.selectedOperatorServiceGroupById(serviceGroupId);
    if (!serviceGroup) {
      return;
    }
    serviceGroup.groupServices.forEach((service) => {
      dataRows.push(
        <tr key={`operator-${selectedOperator.id}-${sha1(serviceGroup.name)}-${sha1(service.name)}-group`}>
          <th>{service.name}</th>
          <td className="text-right">
            <ServicePriceItem service={service} />
          </td>
        </tr>
      );
    });
  }
}

export default inject('roamingStore')(GroupServiceTable);
